<eocm-buffer></eocm-buffer>
<eocm-overlay [visible]="!isLoading"></eocm-overlay>
<div class="current-video" *ngIf="currentVideo">
  <video id="video"
         #videoPlayer
         (play)="endedVideo = false"
         (loadeddata)="loadedDataEvent($event)"
         (progress)="progressEvent($event)"
         (timeupdate)="updateTime()"
         (ended)="ended()"
         (seeked)="onSeeked()"
         [poster]="currentVideo.poster"
         playsinline
         crossorigin
         preload="auto"
  >
    <source [src]="currentVideo.url" type="video/mp4" (error)="onError($event)"/>
  </video>
  <eocm-frame-accurate [player]="videoPlayer" [currentVideo]="currentVideo" [(jumpPerformed)]="jumpPerformed"></eocm-frame-accurate>
</div>
<eocm-audio></eocm-audio>
<eocm-error></eocm-error>
<eocm-api></eocm-api>
<eocm-video-interaction></eocm-video-interaction>
